import gql from 'graphql-tag'

const missingStocksGetQuery = gql`
  query missingStocksGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object) {
    missingStocksGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: true })
      @rest(type: "MissingStocksResult", method: "POST", path: "missing-stock/list") {
      results
      paging
    }
  }
`

export default missingStocksGetQuery
